export default {"src":"/_next/static/media/404.245c8995.svg","height":571,"width":860};